const items = [
  {
    id: 'feat-1',
    icon: 'ri-flashlight-line',
    title: '极速追踪',
    desc: '7x24小时全天候监测各大社交平台与新闻渠道，重大网红爆料事件发生后最快1小时内上线报道，让你永远快人一步吃到最新鲜的瓜。',
  },
  {
    id: 'feat-2',
    icon: 'ri-file-search-line',
    title: '深度深扒',
    desc: '不止于表面信息。编辑团队深入调查每件网红争议事件的来龙去脉，提供完整的时间线、多方视角和关键证据，让吃瓜也有深度。',
  },
  {
    id: 'feat-3',
    icon: 'ri-shield-check-line',
    title: '信息把关',
    desc: '每条爆料均标注信息来源和可信度评估。未经证实的传闻明确标注"待核实"，虚假信息绝不传播，做负责任的吃瓜信息平台。',
  },
  {
    id: 'feat-4',
    icon: 'ri-stack-line',
    title: '分类清晰',
    desc: '按直播带货、人设崩塌、MCN内幕等九大专题分类整理，支持按热度、时间筛选。无论是追最新瓜还是回顾经典事件，都能快速找到。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="w-full py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-6xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-6 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">平台特色</h2>
          <span className="text-xs text-foreground-500 bg-secondary-100 px-2 py-0.5 rounded-full">为什么选择我们</span>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((item) => (
            <div key={item.id} className="bg-background-50 rounded-lg border border-secondary-200/60 p-5 md:p-6 text-center group hover:border-primary-300 transition-all cursor-default">
              <div className="w-12 h-12 md:w-14 md:h-14 rounded-lg bg-primary-100 flex items-center justify-center mx-auto mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl md:text-2xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-bold text-foreground-950 mb-2">{item.title}</h3>
              <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}